// extracted by mini-css-extract-plugin
module.exports = {"AddNoteOption":"styles_AddNoteOption__crtY2"};